import { useEffect } from 'react';
import { LoadReferenceGenerationsCommand } from '../../../core/reference/commands/LoadReferenceGenerationsCommand';
import { isReferenceGenerationActiveQuery } from '../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../types';

const POLL_EVERY_MS = 15000;

/** Loads the generations when the page opens, then every 15 s while one is in progress. */
export const useReferenceGenerationPolling = () => {
    const dispatch = useAppDispatch();
    const isActive = useAppSelector(isReferenceGenerationActiveQuery);

    useEffect(() => {
        dispatch(LoadReferenceGenerationsCommand());
    }, []);

    useEffect(() => {
        if (!isActive) return undefined;

        const intervalId = setInterval(() => dispatch(LoadReferenceGenerationsCommand()), POLL_EVERY_MS);

        return () => clearInterval(intervalId);
    }, [isActive]);
};
